import request from './request';
/**
 *  常停地点列表
 */
export function getFrequentParking(params) {
    return request('/stat/driving/frequent-parking', {
        method: 'GET',
        params,
        timeout: 120 * 1000,
        headers: {
            'Cancel-Message': true,
        },
    });
}

/**
 *  常去地点列表
 */
export function getOftenGo(params) {
    return request('/stat/driving/often-go', {
        method: 'GET',
        params,
        timeout: 120 * 1000,
        headers: {
            'Cancel-Message': true,
        },
    });
}

/**
 *  店铺某常去地点周围的辐射车辆
 */
export function getRadialVehicle(params) {
    return request('/stat/driving/location-radiation-vehicles', {
        method: 'GET',
        params,
    });
}
